var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AppointmentLetterPermanent.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-183ebb50!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AppointmentLetterPermanent.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/components/AppointmentLetterPermanent.vue
// module id = 731
// module chunks = 0